import React from 'react';
import { IndicativeHighlight } from 'web-ui-components/lib/typography/highlights';
import { Identifier } from 'web-ui-components/lib/typography/modifiers';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import { formatAmount, getCurrencyPrefix } from '../../../helpers/fieldHelpers';
import { MANDATE_TYPE_BACS_CREDIT, MANDATE_TYPE_BACS_DEBIT } from '../../../config';
import { formatSortCode } from '../../../utils/accountUtils';

export const inActiveListingColumns = (selectedColumn) => {
	const columns = [
		{
			title: 'From',
			id: 'from',
			path: ['from'],
			sortDirection: 'asc',
		},
		{
			title: '',
			id: 'paymentUploadIcon',
			path: ['paymentUploadIcon'],
		},
		{
			title: 'To',
			id: 'To',
			path: ['to'],
			sortDirection: 'asc',
		},
		{
			title: 'Type',
			id: 'mandateType',
			path: ['mandateType'],
			sortDirection: 'asc',
		},
		{
			title: 'Amount',
			id: 'amount',
			path: ['formatedAmount'],
			alignment: 'right',
			sortDirection: 'asc',
		},
		{
			title: 'Options',
			id: 'options',
			path: ['options'],
			alignment: 'center',
			isHiddenForPrint: true,
		},
	];
	const sortedColumn = columns.filter((column) => column.id === selectedColumn.id);
	sortedColumn[0].sortDirection = selectedColumn.sortDirection;
	return columns;
};

export const activePaymentsColumn = (selectedColumn) => {
	const columns = [
		{
			title: 'From',
			id: 'from',
			path: ['formatedFrom'],
			sortDirection: 'asc',
		},
		{
			title: '',
			id: 'paymentUploadIcon',
			path: ['paymentUploadIcon'],
		},
		{
			title: 'To',
			id: 'to',
			path: ['formatedTo'],
			sortDirection: 'asc',
		},
		{
			title: 'Type',
			id: 'mandateType',
			path: ['mandateType'],
			sortDirection: 'asc',
		},
		{
			title: 'Amount',
			id: 'amount',
			path: ['formatedAmount'],
			alignment: 'right',
			sortDirection: 'asc',
		},
		{
			title: 'Last paid/Next due',
			id: 'when',
			path: ['formatedWhen'],
			alignment: 'center',
			sortDirection: 'asc',
		},
		{
			title: 'Options',
			id: 'options',
			path: ['options'],
			isHiddenForPrint: true,
		},
	];
	const sortedColumn = columns.filter((column) => column.id === selectedColumn.id);
	sortedColumn[0].sortDirection = selectedColumn.sortDirection;
	return columns;
};

export const defaultColumnSort = {
	title: 'From',
	id: 'from',
	path: ['formatedFrom'],
	sortDirection: 'asc',
};
export const formatTo = (mandate) => {
	const { to, reference, bacsName, mandateType } = mandate;
	const showbacsName = mandateType === MANDATE_TYPE_BACS_CREDIT;
	const showComma = reference || showbacsName;
	return (
		<div>
			<div>
				<span>
					<Identifier.Breaking>
						<strong>{to}</strong>
						{showComma && <span>,</span>}
					</Identifier.Breaking>
				</span>
			</div>
			{reference && <Identifier.Truncated characterCount={16} value={reference} />}
			{showbacsName && <small className="u-white-space-nowrap">{bacsName}</small>}
		</div>
	);
};

export const formatFrom = (mandate) => {
	const { from, mandateType, bacsName } = mandate;
	const showbacsName = mandateType === MANDATE_TYPE_BACS_DEBIT;
	return (
		<div>
			<div>
				{!showbacsName && (
					<div>
						<small> {mandate.fromAccount.accountHolder}</small>
					</div>
				)}
				<div>
					<strong>{from}</strong>
				</div>
				{!showbacsName && (
					<div>
						<small>
							{mandate.fromAccount.accountNumber && `${mandate.fromAccount.accountNumber} |`}{' '}
							{formatSortCode(mandate.fromAccount.sortCode)}
						</small>
					</div>
				)}
				{showbacsName && <span>,</span>}
			</div>
			{showbacsName && <small>{bacsName}</small>}
		</div>
	);
};
export const amountFormater = (mandate) => {
	const { amount, currency } = mandate;
	if (currency) {
		return (
			<IndicativeHighlight.description>
				<span>
					<span>{getCurrencyPrefix(currency)}</span>
					{formatAmount(amount)}
					<span> {currency}*</span>
				</span>
			</IndicativeHighlight.description>
		);
	}
	return (
		<span>
			&pound;
			{formatAmount(amount)}
		</span>
	);
};

export const showFileUploadIcon = (showIcon) => {
	if (!showIcon) return null;
	return <Icon iconType="FileLarge" size="sm" className="u-margin-x-auto u-margin-bottom-2" />;
};
